import advisorTheme from './advisorTheme';
import investorTheme from './investorTheme';
import opsTheme from './opsTheme';

export default {
  advisor: advisorTheme,
  investor: investorTheme,
  ops: opsTheme,
};
